import { TranslationSetInput, UserType } from "@src/types.generated";
import { RoleGroupThinFragment } from "@src/features/roles/hooks/useRoleGroups.generated";

export type Group = {
  id: number;
  name: string;
};

export type Employee = {
  id: number;
  name?: string | null;
};

export const hasRecipients = (
  allLocations: boolean,
  allTrainees: boolean,
  allManagers: boolean,
  allAdmins: boolean,
  users: Employee[],
  locations: Group[],
  roles: Group[],
  roleGroups: RoleGroupThinFragment[],
): boolean => {
  if (users.length > 0) {
    return true;
  } else if (
    locations.length > 0 ||
    roles.length > 0 ||
    roleGroups.length > 0
  ) {
    return true;
  } else if (allLocations || allTrainees || allManagers || allAdmins) {
    return true;
  } else {
    return false;
  }
};

export const confirmCopy = (
  isEdit: boolean,
  isScheduled: boolean,
  isDisabled: boolean,
): string => {
  const action = isScheduled ? "Schedule" : "Send";
  if (isEdit && isScheduled) {
    return "Update message";
  } else if (isDisabled) {
    return `${action} message`;
  } else {
    return ` 🚀 ${action} message`;
  }
};

export function isTranslationSetEmpty(ts: TranslationSetInput): boolean {
  return ts.en === "" || ts.en === "<p></p>";
}

const USER_TYPE_RANK: Record<UserType, number> = {
  [UserType.Employee]: 0,
  [UserType.Manager]: 1,
  [UserType.Admin]: 2,
};

// Raising needs an email. Lowering or re-saving never demands one the user
// does not have, but cannot blank one they do.
export const isEmailRequiredForUserType = ({
  from,
  to,
  hasEmail,
}: {
  from: UserType;
  to: UserType;
  hasEmail: boolean;
}): boolean =>
  USER_TYPE_RANK[to] > USER_TYPE_RANK[from] ||
  (hasEmail && to !== UserType.Employee);
